import React from 'react'
import {MDBBtn, MDBRow, MDBCol} from 'mdbreact'
import classes from './SubscribedListItem.module.css'
import {Link} from "react-router-dom";

const SubscribedListItem = (props) => {
    return (
        <MDBRow>
            <MDBCol size={2} >
                <div className={classes.icon}>
                    <img src={props.community.avatar} className={classes.UserIcon} alt='community icon'/>

                </div>
            </MDBCol>
            <MDBCol size={6}>
                <Link
                    to={{
                        pathname: '/community/' + props.id,
                        state: {community: props.community}
                    }}

                >
                    <h3 className={classes.SchoolName}>
                        {props.community.titleCHI}
                    </h3>
                </Link>

            </MDBCol>

            <MDBCol size={4} className={classes.SubscribeBtn}>
                <MDBBtn color='danger' outline className={classes.SubscribeBtn}
                        onClick={() => props.unsubscribe(props.id)}
                >
                    取消訂閱
                </MDBBtn>
            </MDBCol>

        </MDBRow>
    )
}
export default SubscribedListItem